var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaderboardActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{opacity:1;isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leaderboard_selected",
    "data-name": "leaderboard selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fi-rr-crown",
    className: "cls-1",
    d: "M17.08,1.61a1.51,1.51,0,0,0-1.64.33L13.5,3.88,10.06.44a1.49,1.49,0,0,0-2.12,0L4.5,3.88,2.56,1.94A1.5,1.5,0,0,0,0,3v7.94a3.76,3.76,0,0,0,3.75,3.75h10.5A3.76,3.76,0,0,0,18,10.94V3A1.51,1.51,0,0,0,17.08,1.61Zm-.58,9.33a2.25,2.25,0,0,1-2.25,2.25H3.75A2.25,2.25,0,0,1,1.5,10.94V3L4,5.47A.75.75,0,0,0,5,5.47l4-4,4,4a.75.75,0,0,0,1.06,0L16.5,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84523",
    "data-name": "Path 84523",
    className: "cls-2",
    d: "M1,2.31,4.27,4.57,9,.84l4.37,3.73,3.44-2.26L17.2,8s.24,5.4-1.23,5.4-12.19.44-13.32,0S.84,9.38,1,7.32,1,2.31,1,2.31Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardActive);
export default __webpack_public_path__ + "static/media/leaderboard-active.14b567a11b4298a89a192135f660e851.svg";
export { ForwardRef as ReactComponent };